import React, {Component} from "react";
import {withRouter} from 'react-router-dom';
import classes from "./Arrows.module.css";
import {Icon} from '@material-ui/core';
import routeData from '../../../assets/static/routes.json';

class Arrows extends Component {

	getNextRoute(currentPath) {
		currentPath = currentPath.replace('/', '');
		let routes = routeData.routes;
		let route = routes.filter(route => route.link === currentPath)[0];
		let nextRoute = (route.id >= routes.length-1 ) ? routes[0] : routes[route.id + 1];
		return nextRoute.link;
	}
	getPreviousRoute(currentPath) {
		currentPath = currentPath.replace('/', '');
		let routes = routeData.routes;
		let route = routes.filter(route => route.link === currentPath)[0];
		let previousRoute = (route.id <= 0 ) ? routes[routes.length-1] : routes[route.id - 1];
		return previousRoute.link;
	}
	handleNext = () => {
		this.props.history.push(this.getNextRoute(this.props.location.pathname))
	};
	handlePrevious = () => {
		this.props.history.push(this.getPreviousRoute(this.props.location.pathname))
	};
	render() {
		return (
			<div className={classes.Arrows}>
				<ul>
					<li onClick={this.handleNext}><Icon className={classes.Icon} >navigate_next_icon</Icon></li>
					<li onClick={this.handlePrevious}><Icon className={classes.Icon}>navigate_before_icon</Icon></li>
				</ul>
			</div>
		)
	}
}

export default withRouter(Arrows);